export default {
  hero_badge: 'Centro de conocimiento y directorio de recursos',
  hero_title: 'USFans Spreadsheet — encuentra, compara e investiga recursos',
  hero_subtitle:
    'Explora recursos organizados de la hoja de cálculo USFans, información de productos, investigación de vendedores, guías de envío, reseñas, comparaciones y tutoriales prácticos — todo en un solo lugar para que tu investigación sea más rápida y sencilla.',
  hero_cta_primary: 'usfans spreadsheet',
  hero_cta_secondary: 'compra ahora',
  hero_hint: 'Explora productos por categoría o continúa al sitio principal',

  trust_1_title: 'Recursos organizados',
  trust_1_desc: 'Encuentra información útil en un solo lugar estructurado.',
  trust_2_title: 'Investiga más rápido',
  trust_2_desc: 'Compara productos, vendedores y recursos sin perder tiempo.',
  trust_3_title: 'Guías actualizadas',
  trust_3_desc: 'Guías prácticas sobre hojas de cálculo, envío y almacén.',
  trust_4_title: 'La seguridad primero',
  trust_4_desc: 'Aprende a evaluar enlaces, vendedores e información antes de decidir.',

  category_section_title: 'Explora productos por categoría',
  category_section_subtitle:
    'Elige una categoría para explorar productos relacionados directamente en el sitio principal.',
  category_dropdown_label: 'Elige una categoría',
  category_dropdown_placeholder: 'Selecciona una categoría…',
  category_viewAll: 'Ver todas las categorías',

  what_title: '¿Qué es una hoja de cálculo USFans?',
  what_body:
    'Una hoja de cálculo USFans es una forma estructurada de organizar e investigar información de productos, vendedores y recursos. En lugar de buscar en páginas dispersas, puedes usar recursos organizados para descubrir información, comparar opciones y continuar tu investigación de forma más eficiente.',
  what_cta: 'Explora la guía de USFans Spreadsheet',

  guides_title: 'Guías populares de USFans Spreadsheet',
  guides_subtitle:
    'Empieza con estas guías prácticas para entender las hojas de cálculo, la investigación y las comparaciones.',
  guide_1_title: '¿Qué es una hoja de cálculo USFans?',
  guide_1_desc: 'Una introducción clara a las hojas de cálculo y su papel en la organización.',
  guide_2_title: 'Cómo usar una hoja de cálculo USFans',
  guide_2_desc: 'Consejos paso a paso para navegar, comparar y organizar recursos.',
  guide_3_title: 'Directorio USFans Spreadsheet',
  guide_3_desc: 'Una visión general de las principales áreas y categorías de recursos.',
  guide_4_title: 'Guía de vendedores USFans',
  guide_4_desc: 'Qué comprobar antes de confiar en un vendedor o enlace de producto.',
  guide_5_title: 'Investigación de productos USFans',
  guide_5_desc: 'Cómo comparar productos y categorías de forma eficiente.',
  guide_6_title: 'Guía de costes de envío USFans',
  guide_6_desc: 'Entiende qué puede influir en los costes y métodos de envío.',
  guides_viewAll: 'Ver todas las guías',

  // Artículos pilares
  pillar_title: 'Artículos pilares de USFans Spreadsheet',
  pillar_subtitle:
    'Explora nuestra biblioteca completa de guías detalladas sobre hojas de cálculo, productos, vendedores, envíos, cupones, almacén, reseñas y seguridad.',

  info_review_title: 'Reseña de USFans',
  info_review_desc:
    'Explora una visión independiente de USFans: funciones, usabilidad, ventajas potenciales y consideraciones importantes.',
  info_shipping_title: 'Coste de envío de USFans',
  info_shipping_desc:
    'Aprende qué influye en los costes de envío: método, peso del paquete, destino y otras variables.',
  info_legit_title: '¿Es USFans legítimo?',
  info_legit_desc:
    'Comprende qué debes verificar antes de usar una plataforma, vendedor, enlace o servicio.',
  info_cta: 'Explora las guías de USFans',

  compare_title: 'Compara antes de decidir',
  compare_subtitle: 'Usa estas dimensiones para pensar qué es lo más importante para tu investigación.',
  compare_col_feature: 'Característica',
  compare_col_spreadsheet: 'Investigación en hoja',
  compare_col_seller: 'Investigación de vendedor',
  compare_r1_label: 'Profundidad de información',
  compare_r1_a: 'Alta',
  compare_r1_b: 'Media',
  compare_r2_label: 'Facilidad de uso',
  compare_r2_a: 'Fácil',
  compare_r2_b: 'Moderada',
  compare_r3_label: 'Ideal para',
  compare_r3_a: 'Investigación detallada',
  compare_r3_b: 'Verificar vendedores',

  safety_title: 'Centro de seguridad USFans',
  safety_body:
    'Antes de usar cualquier hoja de cálculo, enlace de producto o información de vendedor, tómate un momento para verificar la fuente y comprender los riesgos. Nuestro Centro de seguridad ofrece orientación práctica para revisar enlaces, vendedores, información de productos y riesgos relacionados con el pago.',
  safety_cta: 'Visita el Centro de seguridad',

  faq_title: 'Preguntas frecuentes',
  faq_subtitle: 'Respuestas rápidas a las preguntas más comunes sobre USFans Spreadsheet.',
  faq_q1: '¿Qué es una hoja de cálculo USFans?',
  faq_a1:
    'Una hoja de cálculo USFans es una forma estructurada de organizar e investigar información de productos, vendedores y recursos.',
  faq_q2: '¿Cómo uso una hoja de cálculo USFans?',
  faq_a2:
    'Empieza eligiendo una categoría o guía, compara los recursos y sigue los enlaces al sitio principal cuando estés listo.',
  faq_q3: '¿Es USFans legítimo?',
  faq_a3:
    'Verifica siempre de forma independiente vendedores, enlaces y detalles de productos antes de decidir o comprar.',
  faq_q4: '¿Cuánto cuesta el envío de USFans?',
  faq_a4:
    'Los costes dependen del método, el peso del paquete y el destino. Consulta el sitio principal para ver los detalles actuales.',
  faq_q5: '¿Dónde encuentro cupones de USFans?',
  faq_a5:
    'Las ofertas cambian con frecuencia, así que consulta el sitio principal para ver las promociones actuales.',
  faq_q6: '¿Qué es el almacén de USFans?',
  faq_a6:
    'El almacén se relaciona con cómo se guardan y envían los productos. Verifica la información más reciente en el sitio principal.',
  faq_q7: '¿Cómo compruebo un vendedor de USFans?',
  faq_a7:
    'Revisa los detalles del producto, compara opciones y verifica la información de forma independiente antes de confiar en un vendedor.',

  final_title: '¿Listo para explorar los recursos de USFans Spreadsheet?',
  final_body:
    'Empieza con nuestras guías, comparaciones y recursos organizados de USFans Spreadsheet, y continúa al sitio principal cuando estés listo para explorar más.',
  final_cta_primary: 'Explora USFans Spreadsheet',
  final_cta_secondary: 'Visita el sitio principal',

  footer_tagline:
    'Un recurso informativo independiente sobre guías, categorías, reseñas e investigación de USFans Spreadsheet.',
  footer_resources: 'Recursos',
  footer_company: 'Empresa',
  footer_legal: 'Legal',
  footer_guides: 'Guías',
  footer_reviews: 'Reseñas',
  footer_shipping: 'Envío',
  footer_safety: 'Seguridad',
  footer_faq: 'Preguntas',
  footer_about: 'Acerca de',
  footer_editorial: 'Política editorial',
  footer_contact: 'Contacto',
  footer_privacy: 'Política de privacidad',
  footer_terms: 'Términos',
  footer_disclaimer: 'Aviso legal',
  footer_languages: 'Idiomas',
  footer_copyright: 'USFansLink.boats — recurso informativo independiente. Todos los derechos reservados.',
  footer_disclaimer_text:
    'USFansLink.boats es un recurso informativo independiente y no es el sitio oficial de USFans. Verifica siempre de forma independiente vendedores, enlaces, productos, precios, información de envío y detalles de transacción.',

  category_shoes: 'Zapatos',
  category_hoodies: 'Sudaderas / Suéteres',
  category_tshirts: 'Camisetas',
  category_jackets: 'Chaquetas',
  category_pants: 'Pantalones / Pantalones cortos',
  category_headwear: 'Gorros',
  category_sets: 'Conjuntos',
  category_underwear: 'Ropa interior',
  category_jersey: 'Camiseta deportiva',
  category_accessories: 'Accesorios',
  category_bags: 'Bolsos',
  category_belts: 'Cinturones',
  category_perfumes: 'Perfumes',
  category_other: 'Otras cosas',
};